import React from 'react';
import {
  NewDeleteIcon
  } from './Icons';
  import { Modal } from 'react-bootstrap';
  import { useTranslation } from 'react-i18next';
const NoifyModal = ({ user, show, onHide, callback,customClass,title, Content, }) => {
    const { t } = useTranslation();

  return (
    <Modal className={customClass} show={show} onHide={onHide} centered size="md">
    <Modal.Header >
      <Modal.Title className="notification-title align-items-center text-dark">{t(title)}</Modal.Title>
      <button className="hide-popup-btn" onClick={onHide}>  <NewDeleteIcon /></button>
      
    </Modal.Header>
    <Modal.Body>
      {t(Content)}
    </Modal.Body>
    <hr/>
    <button onClick={onHide} className="notify-btn">ok</button>
  </Modal>
  )
};

export default NoifyModal;
